import { SLOTS_APIS } from "@/api_framework/api_config";
import { IBookingMembershipOptionItem, IBookingMembershipOptionsResponse } from "@/api_framework/api_modals/Bookings";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});

export const useBookingMembershipOptionsAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [membershipOptions, setMembershipOptions] = useState<IBookingMembershipOptionItem[]>([]);
  const [isMembershipOptionsInProgress, setIsMembershipOptionsInProgress] = useState(false);

  const execute = useCallback(
    async (clinicId: string, petId: string, serviceId?: string): Promise<IBookingMembershipOptionItem[]> => {
      if (!clinicId || !petId) {
        setMembershipOptions([]);
        return [];
      }

      setIsMembershipOptionsInProgress(true);
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response = await axios
          .get(SLOTS_APIS?.MEMBERSHIP_OPTIONS?.baseURL ?? "", {
            params: {
              clinic_id: clinicId,
              pet_id: petId,
              ...(serviceId ? { service_id: serviceId } : {}),
            },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IBookingMembershipOptionsResponse>) => {
            const memberships = res.data?.status ? res.data?.data?.memberships ?? [] : [];
            setMembershipOptions(memberships);
            return memberships;
          })
          .catch((e: AxiosError) => {
            if (e.config?.["curlCommand"]) {
              sendCurl(e.config["curlCommand"]);
            }
            setMembershipOptions([]);
            return [];
          });

        return response;
      } catch (_e: any) {
        setMembershipOptions([]);
        return [];
      } finally {
        setIsMembershipOptionsInProgress(false);
      }
    },
    [configuration, sendCurl],
  );

  return {
    execute,
    membershipOptions,
    isMembershipOptionsInProgress,
  };
};
